
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxLength: {
      type: Number,
      required: false,
    },
    minLength: {
      type: Number,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    hasCharacterCounter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(_props, { emit }) {
    const onInput = async (event: Event) => {
      const input = event.target as HTMLInputElement;

      if (!input.value || input.value === "") {
        emit("update:modelValue", input.value);
        return;
      }

      emit("update:modelValue", input.value);
    };

    return { onInput };
  },
});
